import React from 'react';
import FluidButton from 'ui/FluidButton';
import RingingBellIcon from 'ui/Icons/ringing-bell.component.svg';
import { theme } from '../../../../../tailwind.config';
import { ICrmPerson } from 'services/CrmApi/types/DirectoryEntry';
import UserIcon from 'ui/Icons/components/user.component';

export interface ISubscriptionWindowProps {
  subscribedUsers: ICrmPerson[];
  onButtonClick: () => void;
  isLoading: boolean;
  isSubscribed: boolean;
}

export const SubscriptionWindow: React.FC<ISubscriptionWindowProps> = ({ subscribedUsers, onButtonClick, isLoading, isSubscribed }) => {
  const subscribedUsersCount = subscribedUsers.length > 0 ? subscribedUsers.length : 'none';
  const preventClickPropagation = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <div className="bg-white rounded flex flex-col gap-[20px] p-[15px] shadow-util1" onClick={preventClickPropagation}>
        <div className="flex flex-col gap-[10px]">
          <p className="font-pt-sans text-[17px] text-black whitespace-nowrap overflow-hidden text-ellipsis m-0">
            <span className="font-[700]">Users subscribed</span>
            <span className="font-normal">{` (${subscribedUsersCount})`}</span>
          </p>

          <div className="flex gap-[10px]">
            <div className="flex flex-col gap-[10px] flex-1 max-h-[235px] pr-[20px] overflow-y-auto">
              {subscribedUsers.map((user, index) => (
                <div key={index} className="flex gap-[5px] items-center">
                  <UserIcon className="w-[25px] h-[25px] shrink-0" icon="gray-40" />
                  <p className="font-pt-sans text-[13px] text-black tracking-[0.52px] leading-normal flex-1 min-w-0 m-0">
                    <span className="capitalize">{user.firstName} {user.lastName}</span>
                    <br />
                    <span className="italic lowercase">{user.email}</span>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <FluidButton
            type="secondary"
            textClassName="flex items-center gap-[10px]"
            isLoading={isLoading}
            onClick={onButtonClick}
          >
            {isSubscribed ? 'Unsubscribe' : 'Subscribe'}
            <RingingBellIcon className="w-[18px] h-[18px]" fill={theme.colors['brown-prime']} />
          </FluidButton>
      </div>
  );
};